{
  "moreActions": "Więcej akcji"
}
